import axiosInstance from "./axiosInstance";

const obtenerTitular = async (id) => {
  return await axiosInstance.get(
    `${process.env.REACT_APP_BASE_URL}/obtenerTitular?titularId=${id}`,
    { withCredentials: true }
  );
};

export default obtenerTitular;
